import { FC } from 'react';
import { useFragment } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import Link from '@mui/material/Link';
import TableCell from 'components/TableCell';
import SortableEntityTableRow, {
  SortableEntityTableRowProps,
} from 'components/SortableEntityTableRow';

import { CategoryListRow_category$key } from '__generated__/CategoryListRow_category.graphql';

type Props = SortableEntityTableRowProps & {
  category: CategoryListRow_category$key;
};

const CategoryListRow: FC<Props> = ({ category, ...props }) => {
  const entity = useFragment(
    graphql`
      fragment CategoryListRow_category on Category {
        id
        name

        ...SortableEntityTableRow_entity
      }
    `,
    category
  );

  const { id, name } = entity;

  return (
    <SortableEntityTableRow entity={entity} {...props}>
      <TableCell>
        <Link href={id}>{name}</Link>
      </TableCell>
    </SortableEntityTableRow>
  );
};

export default CategoryListRow;
